var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar2 = function SvgStar2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 27"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.234 1.62q.448-.897 1.444-.897t1.445.896l3.237 6.575 7.273 1.096q.996.1 1.295 1.046t-.399 1.644l-5.28 5.13 1.246 7.273q.15.946-.648 1.494-.797.597-1.644.15l-6.525-3.388-6.525 3.387q-.846.499-1.644-.1-.796-.597-.647-1.543l1.245-7.273-5.28-5.13Q.13 11.283.43 10.336.728 9.39 1.724 9.29l7.272-1.096z"
  })));
};
export default SvgStar2;